import { createRoot } from "react-dom/client"
import { ReactQueryProvider } from "source/ReactQueryProvider"

export const launchAsyncModal = (Component, props) => {
  return new Promise((resolve) => {
    const dialogContainer = document.createElement("div")
    const dialogRoot = createRoot(dialogContainer)

    const cleanup = () => {
      dialogRoot.unmount(dialogContainer)
    }

    const handleCancel = () => {
      cleanup()
      resolve(false)
    }

    const handleConfirm = () => {
      cleanup()
      resolve(true)
    }

    dialogRoot.render(
      <ReactQueryProvider>
        <Component
          {...props}
          onCancel={handleCancel}
          onConfirm={handleConfirm}
        />
      </ReactQueryProvider>,
      dialogContainer,
    )
  })
}
